// packages/shared/src/rules/aquarium.ts
import { tuning, type ShadowSize } from '@whiskerton/content';
export function tankFootprint(size: ShadowSize): readonly [number, number] {
  return tuning.decor.tankBySize[size] as readonly [number, number];
}
